import React, { useState } from "react";
import styled from "@emotion/styled";
import { withTheme } from "@emotion/react";
import { darken } from "polished";
import { Search as SearchIcon } from "react-feather";
import { useTranslation } from "react-i18next";

import { Drawer, Grid, InputBase, AppBar as MuiAppBar, IconButton as MuiIconButton, Toolbar, Tooltip } from "@mui/material";

import {
  Menu as MenuIcon,
  SettingsOutlined as SettingsIcon,
  DarkModeOutlined as DarkModeIcon,
  LightModeOutlined as LightModeIcon,
} from "@mui/icons-material";

import NavbarNotificationsDropdown from "./NavbarNotificationsDropdown";
import NavbarMessagesDropdown from "./NavbarMessagesDropdown";
import NavbarLanguagesDropdown from "./NavbarLanguagesDropdown";
import NavbarUserDropdown from "./NavbarUserDropdown";
import { ThemeDrawerContent } from "../Settings";
import useTheme from "../../hooks/useTheme";
import { THEMES } from "../../constants";

const AppBar = styled(MuiAppBar)`
  background: ${(props) => props.theme.header.background};
  color: ${(props) => props.theme.header.color};
`;

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

const Search = styled.div`
  border-radius: 2px;
  background-color: ${(props) => props.theme.header.background};
  display: none;
  position: relative;
  width: 100%;

  &:hover {
    background-color: ${(props) => darken(0.05, props.theme.header.background)};
  }

  ${(props) => props.theme.breakpoints.up("md")} {
    display: block;
  }
`;

const SearchIconWrapper = styled.div`
  width: 50px;
  height: 100%;
  position: absolute;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 22px;
    height: 22px;
  }
`;

const Input = styled(InputBase)`
  color: inherit;
  width: 100%;

  > input {
    color: ${(props) => props.theme.header.search.color};
    padding-top: ${(props) => props.theme.spacing(2.5)};
    padding-right: ${(props) => props.theme.spacing(2.5)};
    padding-bottom: ${(props) => props.theme.spacing(2.5)};
    padding-left: ${(props) => props.theme.spacing(12)};
    width: 160px;
  }
`;

const Navbar = ({ onDrawerToggle }) => {
  const { t } = useTranslation();
  const [themeDrawerOpen, setThemeDrawerOpen] = useState(false);
  const { theme: currentTheme, setTheme } = useTheme();
  const isDark = currentTheme === THEMES.DARK;
  const toggleDarkMode = () => setTheme(isDark ? THEMES.DEFAULT : THEMES.DARK);

  return (
    <React.Fragment>
      <AppBar position="sticky" elevation={0}>
        <Toolbar>
          <Grid container alignItems="center">
            <Grid item sx={{ display: { xs: "block", md: "none" } }}>
              <IconButton color="inherit" aria-label="Open drawer" onClick={onDrawerToggle} size="large">
                <MenuIcon />
              </IconButton>
            </Grid>
            <Grid item>
              {/*
              <Search>
                <SearchIconWrapper>
                  <SearchIcon />
                </SearchIconWrapper>
                <Input placeholder={t("Search")} />
              </Search>
              */}
            </Grid>
            <Grid item xs />
            <Grid item>
              {/*
              <NavbarMessagesDropdown />
              <NavbarLanguagesDropdown />
              */}
              <NavbarNotificationsDropdown />
              <Tooltip title={isDark ? "Switch to light mode" : "Switch to dark mode"}>
                <IconButton color="inherit" onClick={toggleDarkMode} size="large">
                  {isDark ? <LightModeIcon /> : <DarkModeIcon />}
                </IconButton>
              </Tooltip>
              <Tooltip title="Settings">
                <IconButton color="inherit" onClick={() => setThemeDrawerOpen(true)} size="large">
                  <SettingsIcon />
                </IconButton>
              </Tooltip>
              <NavbarUserDropdown />
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <Drawer anchor="right" open={themeDrawerOpen} onClose={() => setThemeDrawerOpen(false)}>
        <ThemeDrawerContent />
      </Drawer>
    </React.Fragment>
  );
};

export default withTheme(Navbar);
